define('core/helper/Utilities',[
	'jQuery',
], function ($) {
	'use strict';

	var module = {
		_loadCss: false,
	};

	// http://stackoverflow.com/a/13382873/5649903
	module.getScrollbarWidth = function() {
		var outer = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.width = '100px';
		outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

		document.body.appendChild(outer);

		var widthNoScroll = outer.offsetWidth;
		// force scrollbars
		outer.style.overflow = 'scroll';

		// add innerdiv
		var inner = document.createElement('div');
		inner.style.width = '100%';
		outer.appendChild(inner);

		var widthWithScroll = inner.offsetWidth;

		// remove divs
		outer.parentNode.removeChild(outer);

		return widthNoScroll - widthWithScroll;
	};


	// parseUri 1.2.2-p2media
	// (c) Steven Levithan <stevenlevithan.com>
	// http://blog.stevenlevithan.com/archives/parseuri
	// (c) Moritz Ngo <moritz.ngo@p2media.de>
	// Modified
	// MIT License
	module.parseUri = function (str, options) {
		options = $.extend(true, {}, module.parseUri.defaults, options);
		var matches = options.parser[options.strictMode ? 'strict' : 'loose'].exec(str),
			query = options.query,
			key = options.key,
			i = key.length,
			uri = {}
		;

		while (i--) {
			uri[key[i]] = matches[i] || '';
		}

		uri[query.name] = {};
		uri.query.replace(query.parser, function ($0, $1, $2) {
			if ($1) {
				uri[query.name][$1] = $2;
			}
		});

		return uri;
	};
	module.parseUri.defaults = {
		strictMode: false,
		key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
		query: {
			name: 'queryKey',
			parser: /(?:^|&)([^&=]*)=?([^&]*)/g
		},
		parser: {
			strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
			loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
		}
	};


	// (c) Moritz Ngo <moritz.ngo@p2media.de>
	module.buildQueryString = function (obj, prefix) {
		var ret = [];
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
			}
		}
		return ret.join('&');
	};


	return module;
});

